<template>
    <div>
        <button
            :class="buttonClass"
            @click="$modal.show('edit-mac-address')"
        >
            <slot>Redigera</slot>
        </button>

        <adaptive-form-modal
            name="edit-mac-address"
            title="Redigera MAC-adress"
            method="patch"
            :action="route('api.delivery-projects.addresses.mac-address.update', address.id)"
            :redirect-to="redirectTo"
        >
            <text-input
                v-model="macAddress"
                :required="true"
                :autofocus="true"
                :maxlength="17"
                name="mac_address"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>

    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            redirectTo: {
                type: String,
                required: true,
            },
            buttonClass: {
                type: String,
                default: 'btn btn-md is-primary',
            },
        },

        data() {
            return {
                macAddress: this.address.mac_address,
            };
        },

        watch: {
            macAddress(newValue) {
                let c = '';
                const isFullLength = newValue.replace(/:/g, '').length >= 12;
                const upperCase = newValue.toUpperCase();
                let withoutInvalidChars = '';

                for (let i = 0; i < upperCase.length; i++) {
                    c = upperCase[i];

                    if (c === ':') continue;

                    if (isFullLength ? i < 5 : i < 4) {
                        c = c.replace(/[^ -~]/g, '');
                    } else {
                        c = c.replace(/[^A-F0-9]/g, '');
                    }

                    withoutInvalidChars = withoutInvalidChars + c;
                }

                const withoutDashes = withoutInvalidChars.replace(/-/g, '');

                let normalized = withoutDashes;

                if (isFullLength) {
                    if (this.isPlainMacAddressMatch(normalized)) {
                        normalized = normalized.replace(/(.{2})/g, '$1:').substring(0, 17);
                    } else {
                        normalized = normalized.substring(0, 12);
                    }
                }

                this.$nextTick(() => {
                    this.macAddress = normalized;
                });
            },
        },

        methods: {
            isPlainMacAddressMatch: function (val) {
                if (! val) return false;

                return val.match(/^[a-fA-F0-9]{12}$/);
            },
        },

    };
</script>
